import { convertDigitToProperFormat } from 'utils/number';
import { ICompanyRole, TProjects } from 'store/companies/companiesTypes';
import { getLanguageBaseOnTZ } from '../../../../utils/LanguageLocalStorage';

export default {
  addRole: 'افزودن',
  roleHint: 'مثال: پزشک...',
  roleDescription: 'توضیحات (اختیاری)',
  addRoleToCompany: 'اضافه کردن سمت جدید',
  addDistrict: 'اضافه کردن بخش جدید',
  autoAddPrefix: 'انتخاب خودکار در صورت پیشوند بودن',
  editRole: 'ویرایش سمت',
  editDistrict: 'ویرایش بخش',
  save: 'ذخیره',
  cancel: 'لغو',
  isProjectRole: 'نقش درون پروژه‌ای',
  projectTypes: 'نوع پروژه',
  editProjectRole: 'ویرایش نقش درون پروژه‌ای',
  migrateProjectRoles: 'مهاجرات به سمت های درون پروژه ای',
  conflictedRoles: 'سمت هایی که با سمت های کنونی مشکل دارند',
  rolesWillBeCreated: 'سمت هایی که ایجاد می‌شوند را انتخاب کنید',
  migrate: 'انجام مهاجرت',
  openToSeeProjectInfoText:
    'برای مشاهده پروژه های مرتبط با هر سمت بر روی آن سمت بزنید',
  surroundingMeRoles: 'سمت های در بر گیرنده این سمت',
  surroundingMeDistrict: 'بخش در بر گیرنده این بخش',
  autoAssignOnly: 'تخصیص فقط به صورت خودکار',
  compoundCreation: 'ساخت سمت ترکیبی',
  compoundCreationIsUnique: 'سمت‌های ترکیبی فقط به یک فرد محول می‌شوند',
  isUnique: 'این سمت فقط به یک فرد محول می‌شود',
  applyIfAllSurroundingExists: 'تخصیص خودکار در صورت تخصیص تمام دربرگیرنده',
  compoundWith: 'ترکیب با',
  Post: 'نقش‌ها',
  District: 'بخش‌ها',
  InProject: 'سمت پروژه‌ای',
  Compound: 'ترکیبی',
  all: 'همه',
  error: 'مشکل دار',
  advanced: 'تنظیمات پیشرفته',
  roleType: 'نوع سمت',
  requireSetRoleType: 'نیازمند تعیین نوع سمت',
  relatedTag: 'برچسب مرتبط',
  autoCreateTag: 'ساخت خودکار تگ مرتبط',
  districtHint: 'مثال :اورژانس',
  migrateRole: 'انتقال نقش ها',
  migrateFrom: 'انتقال از نقش',
  migrateTo: 'انتقال به نقش',
  doneMigrate:
    'انتقال با موفقیت انجام شد. لطفا جهت مشاهده تغییرات سامانه را رفرش کنید (F5)',
  doMigrate: 'انتقال',
  migrateDelete: 'حدف نقش مبدا',

  roleDeleteCheck(role: ICompanyRole) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa')
      return `ایا مطمئن هستید که می‌خواهد سمت «${role.name}» با ${convertDigitToProperFormat(
        role.users.length
      )} عضو حذف شود. توجه کنید که این اقدام غیر قابل برگشت است`;
    else
      return `Are you sure you want to delete the role «${role.name}» with ${convertDigitToProperFormat(role.users.length)} members?
       Please note that this action is irreversible`;
  },
  roleUsedIn(
    oldRole: ICompanyRole,
    projects: TProjects,
    foundProjectIds: number[]
  ) {
    const lang = getLanguageBaseOnTZ();
    const names = foundProjectIds.reduce((current, item) => {
      if (current.length > 0) current += '، ';
      current += projects[item]?.name;
      return current;
    }, '');
    if (lang === 'fa')
      return `سمت «${oldRole.name}» در پروژه های «${names}» استفاده شده است`;
    else return `«${oldRole.name}» is used in the projects «${names}»`;
  },
  tagNameWillBeChange(tagName: string, roleName: string) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa')
      return `پس از ذخیره سازی عنوان تگ «${tagName}» به «${roleName}» تبدیل خواهد شد`;
    else
      return `After saving, the tag title «${tagName}» will be converted to «${roleName}`;
  },
  tagNameWillBeCreated(roleName: string | undefined) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa')
      return ` پس از ذخیره سازی تگ با عنوان «${roleName}» ایجاد خواهد شد`;
    else
      return `After saving, a tag with the title ${roleName} will be created.`;
  },
};
